module.exports = __webpack_public_path__ + "img/getwater.6c94437e.png";